import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import RapportiServizioSection from "../components/RapportiServizioSection";
import RapportiServizioTotaliPreview from "./RapportiServizioTotaliPreview";
import RegistroServizioRiepilogo from "./RegistroServizioRiepilogo";

const RapportiServizio = () => {
  const { user, activeCongregazione } = useAuth();
  const [activeTab, setActiveTab] = useState("rapporti");
  const isAdminOrSuper =
    user?.ruolo === "admin" || user?.ruolo === "super_admin";

  if (!isAdminOrSuper) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8 space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">
              Rapporti di Servizio
            </h1>
            <p className="mt-2 text-sm text-gray-600">
              Consulta e gestisci i rapporti di servizio di tutti i proclamatori
              della congregazione, mese per mese.
            </p>
          </div>
        </div>
        <div className="accent-line mt-3" />
        <div className="mt-5 flex overflow-x-auto rounded-lg border" role="tablist" aria-label="Sezione rapporti di servizio">
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "rapporti"}
            onClick={() => setActiveTab("rapporti")}
            className={`flex-1 min-w-[8rem] px-4 py-2 text-sm font-medium ${
              activeTab === "rapporti"
                ? "bg-primary-600 text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            Rapporti di servizio
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "totali"}
            onClick={() => setActiveTab("totali")}
            className={`flex-1 min-w-[8rem] px-4 py-2 text-sm font-medium ${
              activeTab === "totali"
                ? "bg-primary-600 text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            Totali rapporti
          </button>
          {!activeCongregazione?.servizio_speciale && <button
            type="button"
            role="tab"
            aria-selected={activeTab === "riepilogo"}
            onClick={() => setActiveTab("riepilogo")}
            className={`flex-1 min-w-[8rem] px-4 py-2 text-sm font-medium ${
              activeTab === "riepilogo"
                ? "bg-primary-600 text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            Riepilogo mensile
          </button>}
        </div>
      </div>
      {activeTab === "rapporti" ? (
        <RapportiServizioSection mode="admin" showHeader={false} />
      ) : activeTab === "riepilogo" && !activeCongregazione?.servizio_speciale ? (
        <RegistroServizioRiepilogo key={activeCongregazione?.id} congregazioneId={activeCongregazione?.id} />
      ) : (
        <RapportiServizioTotaliPreview embedded />
      )}
    </div>
  );
};

export default RapportiServizio;
